/* TheFootRevival — theme behaviour */
(function () {
  'use strict';
  var fmt = window.themeMoneyFormat || '${{amount}}';

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace('{{amount}}', whole + '.' + parts[1])
      .replace('{{amount_no_decimals}}', whole)
      .replace('{{amount_with_comma_separator}}', whole.replace(/,/g, '.') + ',' + parts[1])
      .replace('{{amount_no_decimals_with_comma_separator}}', whole.replace(/,/g, '.'))
      .replace(/<[^>]*>/g, '');
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- scroll reveals ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }) : null;
  function bindReveals() {
    var items = $$('.reveal');
    items.forEach(function (el) { if (io) { io.observe(el); } else { el.classList.add('is-in'); } });
    // safety net: never leave a section invisible if the observer misfires
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  }

  /* ---------- countdown ---------- */
  function bindCountdown() {
    var host = $('[data-countdown]');
    var minutes = host ? parseInt(host.getAttribute('data-minutes'), 10) || 20 : 20;
    var key = 'tfr-countdown-end';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!end || end < Date.now()) { end = Date.now() + minutes * 60000; sessionStorage.setItem(key, String(end)); }
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (left === 0) { end = Date.now() + minutes * 60000; sessionStorage.setItem(key, String(end)); left = minutes * 60; }
      var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      $$('[data-cd-h]').forEach(function (n) { n.textContent = pad(h); });
      $$('[data-cd-m]').forEach(function (n) { n.textContent = pad(m); });
      $$('[data-cd-s]').forEach(function (n) { n.textContent = pad(s); });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- live viewer count ---------- */
  function bindViewing() {
    var el = $('[data-viewing]');
    if (!el) return;
    var n = parseInt(el.textContent, 10) || 38;
    setInterval(function () {
      n = Math.min(96, Math.max(18, n + (Math.random() < 0.5 ? -1 : 1) * (1 + Math.floor(Math.random() * 3))));
      el.textContent = String(n);
    }, 4200);
  }

  /* ---------- delivery dates ---------- */
  function bindDates() {
    $$('[data-date-offset]').forEach(function (el) {
      var off = parseInt(el.getAttribute('data-date-offset'), 10) || 0;
      var d = new Date();
      d.setDate(d.getDate() + off);
      el.textContent = off === 0 ? 'Today' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
    });
  }

  /* ---------- accordions ---------- */
  function bindAccordions() {
    $$('[data-accordion]').forEach(function (acc) {
      acc.addEventListener('click', function (e) {
        var btn = e.target.closest('.acc__btn');
        if (!btn || !acc.contains(btn)) return;
        var item = btn.closest('.acc__item');
        var open = item.getAttribute('data-open') === 'true';
        $$('.acc__item', acc).forEach(function (i) {
          i.setAttribute('data-open', 'false');
          var b = $('.acc__btn', i); if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) { item.setAttribute('data-open', 'true'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---------- gallery ---------- */
  function bindGallery() {
    var thumbs = $$('[data-gallery-thumb]');
    if (!thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-gallery-thumb');
        thumbs.forEach(function (o) { o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
        $$('[data-gallery-img]').forEach(function (img) {
          img.hidden = img.getAttribute('data-gallery-img') !== i;
        });
        thumbs.forEach(function (o) {
          var on = o.getAttribute('aria-selected') === 'true';
          o.style.borderColor = on ? '#14504C' : '#E9E4DA';
          o.style.boxShadow = on ? '0 0 0 2px rgba(20,80,76,.18)' : 'none';
        });
      });
    });
    var vp = $('[data-zoom]');
    if (vp) {
      vp.addEventListener('mousemove', function (e) {
        var r = vp.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100, y = ((e.clientY - r.top) / r.height) * 100;
        $$('.gallery__img', vp).forEach(function (img) { img.style.transformOrigin = x + '% ' + y + '%'; });
      });
    }
  }

  /* ---------- size guide ---------- */
  function bindSizeGuide() {
    var modal = $('[data-size-guide]');
    if (!modal) return;
    function open() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
    $$('[data-size-guide-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-size-guide-close]').forEach(function (b) { b.addEventListener('click', close); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    $$('[data-size-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        var label = card.getAttribute('data-size-card');
        $$('[data-size-card]').forEach(function (o) { o.setAttribute('aria-checked', o === card ? 'true' : 'false'); });
        var target = $$('.size-btn').filter(function (b) { return b.getAttribute('data-option-value') === label; })[0];
        if (target) target.click();
        close();
      });
    });
  }

  /* ---------- review form ---------- */
  function bindReviewForm() {
    var modal = $('[data-review-modal]');
    if (!modal) return;
    function open() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
    $$('[data-review-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-review-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    var stars = $$('[data-star]', modal);
    var hidden = $('[data-review-rating]', modal);
    stars.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = parseInt(btn.getAttribute('data-star'), 10);
        if (hidden) hidden.value = String(n);
        stars.forEach(function (o) {
          var on = parseInt(o.getAttribute('data-star'), 10) <= n;
          o.style.color = on ? 'var(--star)' : '#DDE5E2';
          o.setAttribute('aria-checked', parseInt(o.getAttribute('data-star'), 10) === n ? 'true' : 'false');
        });
      });
    });
    if (window.location.search.indexOf('contact_posted=true') > -1) open();
  }

  /* ---------- product form: variants, bundles, quantity ---------- */
  function bindProductForm() {
    var root = $('[data-product-form]');
    if (!root) return;
    var variants = [];
    try {
      var jsonEl = $('[data-variant-json]', root);
      variants = jsonEl ? JSON.parse(jsonEl.textContent || '[]') : [];
    } catch (e) { variants = []; }
    var form = $('[data-add-form]', root);
    var idInput = $('[data-variant-id]', root);
    var qtyInput = $('[data-quantity-input]', root);
    var qtyOut = $('[data-qty-display]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var saveEl = $('[data-save]', root);
    var addBtn = $('[data-add-btn]', root);
    var barPrice = $('[data-bar-price]');
    var barMeta = $('[data-bar-meta]');
    var state = { qty: 1, bundle: null };

    function selectedOptions() {
      return $$('[data-option-index]', root).map(function (group) {
        var picked = $$('[role="radio"]', group).filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0];
        return picked ? picked.getAttribute('data-option-value') : null;
      });
    }
    function matchVariant() {
      var opts = selectedOptions();
      if (!opts.length || !variants.length) return variants[0];
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      })[0];
    }
    function activeBundle() { return $('[data-bundle][data-active="true"]:not([data-addon])', root); }

    function paintBundles() {
      $$('[data-bundle]', root).forEach(function (card) {
        var on = card.getAttribute('data-active') === 'true';
        card.style.borderColor = on ? '#14504C' : '#E9E4DA';
        card.style.background = on ? '#F7FBF9' : '#FFFFFF';
        card.style.boxShadow = on ? '0 16px 32px -26px rgba(20,80,76,.9)' : 'none';
        var radio = card.querySelector('.bundle__radio');
        if (radio) radio.style.border = on ? '6px solid #14504C' : '1.5px solid #C5CFCA';
        var ribbon = card.querySelector('.bundle__ribbon');
        if (ribbon) ribbon.style.background = on ? '#E2622F' : '#B08A4A';
        var pill = card.querySelector('.bundle__name');
        if (pill && pill.nextElementSibling) {
          pill.nextElementSibling.style.background = on ? '#14504C' : '#EEF4F2';
          pill.nextElementSibling.style.color = on ? '#FFFFFF' : '#14504C';
        }
        var btn = card.querySelector('.bundle__btn');
        if (btn) btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function paintOptions() {
      $$('.swatch', root).forEach(function (b2) {
        var on = b2.getAttribute('aria-checked') === 'true';
        b2.style.borderColor = on ? '#14504C' : '#DDE5E2';
        b2.style.background = on ? '#F7FBF9' : '#FFFFFF';
      });
      $$('.size-btn', root).forEach(function (b2) {
        var on = b2.getAttribute('aria-checked') === 'true';
        b2.style.background = on ? '#14504C' : '#FFFFFF';
        b2.style.color = on ? '#FFFFFF' : '#21302C';
        b2.style.borderColor = on ? '#14504C' : '#DDE5E2';
      });
      if (addon) {
        var aon = addon.getAttribute('data-active') === 'true';
        addon.style.borderColor = aon ? '#14504C' : '#E9E4DA';
        addon.style.background = aon ? '#F7FBF9' : '#FFFFFF';
        var box = $('[data-addon-box]', addon);
        if (box) {
          box.style.background = aon ? '#14504C' : '#FFFFFF';
          box.style.borderColor = aon ? '#14504C' : '#C5CFCA';
          box.style.color = aon ? '#FFFFFF' : 'transparent';
        }
      }
      $$('[data-gallery-thumb]', root).forEach(function (t) {
        var on = t.getAttribute('aria-selected') === 'true';
        t.style.borderColor = on ? '#14504C' : '#E9E4DA';
        t.style.boxShadow = on ? '0 0 0 2px rgba(20,80,76,.18)' : 'none';
      });
    }
    function fallbackProps() {
      var props = {};
      $$('[data-fallback-option]', root).forEach(function (group) {
        var picked = $$('[data-fallback-value]', group).filter(function (x) { return x.getAttribute('aria-checked') === 'true'; })[0];
        if (picked) props[group.getAttribute('data-fallback-option')] = picked.getAttribute('data-fallback-value');
      });
      return props;
    }
    var addon = $('[data-addon]', root);

    function render() {
      paintBundles();
      paintOptions();
      var v = matchVariant();
      var b = activeBundle();
      var mult = b ? parseInt(b.getAttribute('data-qty'), 10) || 1 : 1;
      state.qty = mult * (state.qtyMultiplier || 1);
      var tierPrice = b ? Math.round(parseFloat(b.getAttribute('data-price')) * 100) || 0 : 0;
      var tierWas = b ? Math.round(parseFloat(b.getAttribute('data-was')) * 100) || 0 : 0;
      var m2 = state.qtyMultiplier || 1;
      var addonCents = addon && addon.getAttribute('data-active') === 'true'
        ? parseInt(addon.getAttribute('data-price-cents') || '0', 10) : 0;
      var showTotal = tierPrice * m2 + addonCents;
      var showWas = tierWas * m2 + addonCents;
      if (priceEl && showTotal) priceEl.textContent = money(showTotal);
      if (compareEl) compareEl.textContent = showWas > showTotal ? money(showWas) : '';
      if (saveEl) { saveEl.hidden = !(showWas > showTotal); saveEl.textContent = 'Save ' + money(Math.max(0, showWas - showTotal)); }
      if (barPrice && showTotal) barPrice.textContent = money(showTotal);
      if (v) {
        idInput.value = v.id;
        var unit = v.price || 0;
        var was = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
        var bundlePrice = b ? Math.round(parseFloat(b.getAttribute('data-price')) * 100) : unit;
        var bundleWas = b ? Math.round(parseFloat(b.getAttribute('data-was')) * 100) : was;
        var total = (bundlePrice || unit * mult) * (state.qtyMultiplier || 1);
        var totalWas = (bundleWas || was * mult) * (state.qtyMultiplier || 1);
        if (addon && addon.getAttribute('data-active') === 'true') {
          var ap = parseInt(addon.getAttribute('data-price-cents') || '0', 10);
          total += ap; totalWas += ap;
        }
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.getAttribute('data-label') || addBtn.textContent.replace(/^Sold out$/, 'Add to cart')) : 'Sold out';
        if (!v.available) addBtn.textContent = 'Sold out';
      }
      qtyInput.value = String(mult * (state.qtyMultiplier || 1));
      if (qtyOut) qtyOut.textContent = String(state.qtyMultiplier || 1);
      if (barMeta) {
        var picks = selectedOptions().filter(Boolean);
        var fb = fallbackProps();
        Object.keys(fb).forEach(function (k) { picks.push(fb[k]); });
        barMeta.textContent = picks.length ? ' · ' + picks.join(' · ') : '';
      }
      // disable sizes with no available variant
      $$('[data-option-index]', root).forEach(function (group, gi) {
        if (gi === 0) return;
        $$('[role="radio"]', group).forEach(function (btn) {
          var opts = selectedOptions();
          opts[gi] = btn.getAttribute('data-option-value');
          var hit = variants.filter(function (v) { return opts.every(function (o, i) { return o === null || v.options[i] === o; }); })[0];
          if (hit && !hit.available) btn.setAttribute('disabled', 'disabled'); else btn.removeAttribute('disabled');
        });
      });
    }

    state.qtyMultiplier = 1;
    if (addBtn) addBtn.setAttribute('data-label', addBtn.textContent.trim());

    $$('[data-option-index] [role="radio"]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        $$('[role="radio"]', group).forEach(function (o) { o.setAttribute('aria-checked', o === btn ? 'true' : 'false'); });
        render();
      });
    });
    $$('[data-bundle]', root).forEach(function (card) {
      $('.bundle__btn', card).addEventListener('click', function () {
        $$('[data-bundle]', root).forEach(function (o) {
          o.setAttribute('data-active', o === card ? 'true' : 'false');
          $('.bundle__btn', o).setAttribute('aria-checked', o === card ? 'true' : 'false');
        });
        render();
      });
    });
    $$('[data-fallback-option] [data-fallback-value]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-fallback-option]');
        $$('[data-fallback-value]', group).forEach(function (o) { o.setAttribute('aria-checked', o === btn ? 'true' : 'false'); });
        render();
      });
    });
    if (addon) {
      addon.addEventListener('click', function () {
        var on = addon.getAttribute('data-active') === 'true';
        addon.setAttribute('data-active', on ? 'false' : 'true');
        render();
      });
    }
    var up = $('[data-qty-up]', root), down = $('[data-qty-down]', root);
    if (up) up.addEventListener('click', function () { state.qtyMultiplier = Math.min(9, (state.qtyMultiplier || 1) + 1); render(); });
    if (down) down.addEventListener('click', function () { state.qtyMultiplier = Math.max(1, (state.qtyMultiplier || 1) - 1); render(); });

    var statusEl = $('[data-add-status]', root);
    function status(msg, bad) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
      statusEl.style.display = msg ? 'block' : 'none';
      statusEl.style.color = bad ? '#C9451A' : 'var(--teal)';
    }
    function submit() {
      var bundle = activeBundle();
      var code = bundle ? bundle.getAttribute('data-code') : '';
      var id = idInput.value;
      var quantity = parseInt(qtyInput.value, 10) || 1;
      if (!id) { status('Pick a colour and size first.', true); return; }
      var label = addBtn.getAttribute('data-label') || 'Add to cart';
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      status('');
      var props = fallbackProps();
      if (bundle) {
        var nameEl = bundle.querySelector('.bundle__name');
        if (nameEl) props.Bundle = nameEl.textContent.trim();
      }
      var addonOn = addon && addon.getAttribute('data-active') === 'true';
      var addonId = addonOn ? (addon.getAttribute('data-variant') || null) : null;
      if (addonOn && !addonId) props['Shipping protection'] = 'Yes';
      Cart.add(id, quantity, props, addonId).then(function () {
        addBtn.textContent = 'Added ✓';
        setTimeout(function () { addBtn.textContent = label; addBtn.disabled = false; }, 1600);
        if (code) Cart.setDiscount(code);
        Cart.open();
      }).catch(function (err) {
        addBtn.textContent = label;
        addBtn.disabled = false;
        status((err && err.message) || 'Could not add to cart. Please try again.', true);
      });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    if (addBtn) addBtn.addEventListener('click', function (e) { e.preventDefault(); submit(); });
    var barAdd = $('[data-bar-add]');
    if (barAdd) barAdd.addEventListener('click', function (e) { e.preventDefault(); submit(); });

    render();

    /* sticky bar visibility */
    var bar = $('[data-sticky-bar]');
    if (bar) {
      var trigger = form;
      var show = function () {
        var mobile = window.innerWidth <= 900;
        var past = trigger ? trigger.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
        bar.setAttribute('data-show', (mobile || past) ? 'true' : 'false');
      };
      window.addEventListener('scroll', show, { passive: true });
      window.addEventListener('resize', show);
      show();
    }
  }

  /* ---------- cart ---------- */
  var Cart = {
    drawer: null,
    open: function () {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      this.render();
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.hidden = true;
      document.documentElement.style.overflow = '';
    },
    add: function (id, quantity, properties, addonId) {
      var items = [{ id: Number(id), quantity: quantity }];
      if (properties && Object.keys(properties).length) items[0].properties = properties;
      if (addonId) items.push({ id: Number(addonId), quantity: 1 });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart.');
          return d;
        });
      }).then(function (d) { Cart.render(); return d; });
    },
    change: function (key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (d) { Cart.paint(d); return d; });
    },
    setDiscount: function (code) {
      return fetch('/discount/' + encodeURIComponent(code), { method: 'GET' }).catch(function () {});
    },
    render: function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { Cart.paint(d); return d; });
    },
    paint: function (cart) {
      var count = cart.item_count;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = String(count);
        el.setAttribute('data-filled', count > 0 ? 'true' : 'false');
      });
      $$('[data-cart-open]').forEach(function (b) { b.setAttribute('aria-label', 'Cart, ' + count + ' items'); });
      var body = $('[data-drawer-body]');
      var empty = $('[data-drawer-empty]');
      var totalEl = $('[data-drawer-total]');
      var savedEl = $('[data-drawer-saved]');
      var countEl = $('[data-drawer-count]');
      if (countEl) countEl.textContent = count + ' item(s)';
      if (totalEl) totalEl.textContent = money(cart.total_price);
      if (savedEl) {
        var was = cart.items.reduce(function (n, i) {
          var c = i.original_line_price || 0;
          return n + (i.variant_options ? 0 : 0) + c;
        }, 0);
        var save = Math.max(0, was - cart.total_price) + (cart.total_discount || 0);
        savedEl.hidden = save <= 0;
        savedEl.style.display = save > 0 ? '' : 'none';
        savedEl.textContent = 'You save ' + money(save);
      }
      if (!body) return;
      $$('.line', body).forEach(function (n) { n.remove(); });
      if (empty) {
        empty.hidden = count > 0;
        empty.style.display = count > 0 ? 'none' : '';
      }
      cart.items.forEach(function (item) {
        var el = document.createElement('div');
        el.className = 'line';
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : '';
        el.innerHTML =
          (img ? '<img src="' + img + '" alt="" width="58" height="58" loading="lazy">' : '') +
          '<span class="line__info">' +
            '<span class="line__title">' + item.product_title + '</span>' +
            '<span class="line__meta">' + (function () {
              var bits = [];
              if (item.variant_title && item.variant_title !== 'Default Title') bits.push(item.variant_title);
              var pr = item.properties || {};
              Object.keys(pr).forEach(function (k) { if (pr[k] && String(k).charAt(0) !== '_') bits.push(pr[k]); });
              return bits.join(' · ');
            })() + '</span>' +
            '<span style="display:flex;align-items:center;gap:10px;margin-top:4px">' +
              '<span class="line__qty">' +
                '<button type="button" data-line-down aria-label="Decrease quantity">−</button>' +
                '<output>' + item.quantity + '</output>' +
                '<button type="button" data-line-up aria-label="Increase quantity">+</button>' +
              '</span>' +
              '<button type="button" class="line__remove" data-line-remove>Remove</button>' +
            '</span>' +
          '</span>' +
          '<span class="line__price">' +
            '<span class="price" style="font-size:15px">' + money(item.final_line_price) + '</span>' +
            (item.original_line_price > item.final_line_price ? '<span class="bundle__was">' + money(item.original_line_price) + '</span>' : '') +
          '</span>';
        el.querySelector('[data-line-up]').addEventListener('click', function () { Cart.change(item.key, item.quantity + 1); });
        el.querySelector('[data-line-down]').addEventListener('click', function () { Cart.change(item.key, Math.max(0, item.quantity - 1)); });
        el.querySelector('[data-line-remove]').addEventListener('click', function () { Cart.change(item.key, 0); });
        body.insertBefore(el, empty);
      });
    }
  };

  function bindCart() {
    Cart.drawer = $('[data-cart-drawer]');
    $$('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (!Cart.drawer) return;
        e.preventDefault();
        Cart.open();
      });
    });
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { Cart.close(); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && Cart.drawer && !Cart.drawer.hidden) Cart.close();
    });
    Cart.render();
  }

  function init() {
    [bindCart, bindProductForm, bindReviewForm, bindReveals, bindCountdown, bindViewing, bindDates, bindAccordions, bindGallery, bindSizeGuide]
      .forEach(function (fn) {
        try { fn(); } catch (e) { if (window.console) console.error('[theme] ' + fn.name + ':', e); }
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
